<script setup>
import PostSaleStatusDetail from './PostSaleStatusDetail.vue';
import PostSaleStatusChangeFeedback from './PostSaleStatusChangeFeedback.vue';
import PostSaleStatusTransition from './PostSaleStatusTransition.vue';

defineProps({
  agendaAction: { type: String, default: '' },
  caseData: { type: Object, default: null },
  saving: { type: Boolean, default: false },
  selectedStatusEvent: { type: Object, default: null },
  showStatusChangeFeedback: { type: Boolean, default: false },
  showTransition: { type: Boolean, default: false },
  statusOptions: { type: Array, default: () => [] },
});
const emit = defineEmits([
  'closeStatusDetail',
  'closeStatusChangeFeedback',
  'closeTransition',
  'submitTransition',
]);
</script>

<template>
  <PostSaleStatusTransition
    v-if="caseData"
    :agenda-action="agendaAction"
    :catalog="caseData.transition_catalog"
    :case-data="caseData"
    :saving="saving"
    :show="showTransition"
    :status-options="statusOptions"
    @close="emit('closeTransition')"
    @submit="emit('submitTransition', $event)"
  />
  <PostSaleStatusDetail
    :event="selectedStatusEvent"
    :show="Boolean(selectedStatusEvent)"
    @close="emit('closeStatusDetail')"
  />
  <PostSaleStatusChangeFeedback
    :show="showStatusChangeFeedback"
    @close="emit('closeStatusChangeFeedback')"
  />
</template>
